import ajax from 'api/ajax'
// 实验室管理
class laboratory {
    // 获取实验室管理列表
    getLaboratoryList = ( per_page, page ) => ajax('dict-lab/search',{'per-page':per_page, page}, 'get')
    // s删除实验室
    deleteLaboratory = (LAB_NO) => ajax('dict-lab/delete',{LAB_NO}, 'post')
    // 实验室编辑页面
    getLaboratoryDetails = (labno) => ajax('dict-lab/view',{labno}, 'get')
    //  实验室管理表单提交
    LaboratoryUpdate =
        (   LAB_NO,
            LAB_NAME,
            PERSON_NAME,
            PERSON_PHONE,
        )=> ajax('dict-lab/update',
            {
                LAB_NO,
                LAB_NAME,
                PERSON_NAME,
                PERSON_PHONE,
            }, 'post')
    // 新增
    LaboratoryCreate =
        (   LAB_NO,
            LAB_NAME,
            PERSON_NAME,
            PERSON_PHONE,
        )=> ajax('dict-lab/create',
            {
                LAB_NO,
                LAB_NAME,
                PERSON_NAME,
                PERSON_PHONE,
            }, 'post')

    //实验室房间设置
    // 实验室房间获取列表
    getLaboratoryRoomList = ( per_page, page ) => ajax('dict-labroom/search',{'per-page':per_page, page}, 'get')
    // 获取实验室编辑内容
    getLaboratoryRoomDetails = (labroomno) => ajax('dict-labroom/view',{labroomno}, 'get')
    //  获取实验室类型字典 接口有问题
    getLaboratoryType = ( per_page, page ,list) => ajax('dict-lab/search',{'per-page':per_page, page,list}, 'get')


    // 获取实验室人员列表
    getLaboratoryPeopleList = ( per_page, page ) => ajax('chem-user/index',{'per-page':per_page, page}, 'get')

    // 获取实验室人员详细
    getLaboratoryPeopleDetails = (userid) => ajax('chem-user/view',{userid}, 'get')

//    新增实验室人员
    LaboratoryCreatePeople =
        (   CARD_NO,
            MOBILE_PHONE,
            STATUS_MARK,
            USERTYPE_MARK,
            USER_ID,
            USER_NAME,
        )=> ajax('chem-user/create',
            {
                CARD_NO,
                MOBILE_PHONE,
                STATUS_MARK,
                USERTYPE_MARK,
                USER_ID,
                USER_NAME,
            }, 'post')

    //    编辑实验室人员
    LaboratoryUpdatePeople =
        (   CARD_NO,
            MOBILE_PHONE,
            STATUS_MARK,
            USERTYPE_MARK,
            USER_ID,
            USER_NAME,
        )=> ajax('chem-user/update',
            {
                CARD_NO,
                MOBILE_PHONE,
                STATUS_MARK,
                USERTYPE_MARK,
                USER_ID,
                USER_NAME,
            }, 'post')
        // 重置密码
        resetpwd = (USERID) => ajax('chem-user/resetpwd',{USERID}, 'post')
//        删除人员
    deletePeople= (USERID) => ajax('chem-user/delete',{USERID}, 'post')

//  实验室房间管理编辑
    labRoomUpdate = (LABROOM_NAME,LABROOM_NO,LAB_NAME,LAB_NO,PERSON_NAME,PERSON_PHONE) => ajax('dict-labroom/update',{LABROOM_NAME,LABROOM_NO,LAB_NAME,LAB_NO,PERSON_NAME,PERSON_PHONE}, 'post')








}

export default laboratory
